import React from "react";
import { useTranslation } from "react-i18next";

export default function LoadingScreenAnimation() {
  const { t } = useTranslation("labels");
 
  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">
          {t("loading", { ns: "labels" })}
        </span>
      </div>
    </div>
  );
}
